import { queryOptions } from '@tanstack/react-query';

import type { AuthPageData } from './get-auth-page-data.ts';
import { getAuthPageData } from './get-auth-page-data.ts';

export const AUTH_PAGE_QUERY_KEY = ['auth-page-data'] as const;

export function getAuthPageDataQueryOptions() {
	return queryOptions<AuthPageData>({
		queryFn: () => getAuthPageData(),
		queryKey: AUTH_PAGE_QUERY_KEY,
	});
}
